import { createThemeAssets, imageUrl } from '../createThemeAssets'

const themeImages = require.context('./images', true, /\.(png|jpe?g|webp|avif|gif|svg)$/)
const assets = createThemeAssets((path) => themeImages(`./${path}`))

export default {
    name: 'blue',
    label: 'Blue',
    assets,
    cssVars: {
        '--theme-root-bg': '#031735',
        '--theme-page-bg': [
            imageUrl(assets.home.pageBg),
            'radial-gradient(circle at 50% 0, rgba(62, 160, 255, .2) 0, rgba(62, 160, 255, 0) 42%)',
            'linear-gradient(180deg, rgba(8, 56, 128, .5) 0%, rgba(3, 23, 53, .78) 100%)'
        ].join(','),
        '--theme-page-bg-size': 'cover, 100% 7.2rem, 100% 100%',
        '--theme-page-bg-position': 'center top, center top, center top',
        '--theme-header-bg': 'linear-gradient(180deg, rgba(8, 59, 134, .96) 0%, rgba(5, 36, 86, .9) 100%)',
        '--theme-header-control-bg': '#062b61',
        '--theme-header-control-border': '#1e78d5',
        '--theme-header-control-border-gradient': 'linear-gradient(180deg, rgba(91, 178, 255, .35), rgba(43, 137, 242, 1))',
        '--theme-header-accent-bg': 'linear-gradient(180deg, #31a8ff 0%, #075ecb 100%)',
        '--theme-surface-bg': 'rgba(6, 49, 112, .54)',
        '--theme-surface-border': '#347fd8',
        '--theme-soft-text': '#b9dcf7',
        '--theme-bright-text': '#eef9ff',
        '--theme-input-bg': '#062b61',
        '--theme-input-border': '#347fd8',
        '--theme-input-focus-bg': '#073a78',
        '--theme-input-focus-border': '#5dc3ff',
        '--theme-input-focus-border-rgb': '93, 195, 255',
        '--theme-input-placeholder': 'rgba(185, 220, 247, .68)',
        '--theme-list-bg': 'rgba(3, 18, 42, .28)',
        '--theme-list-header-bg': 'rgba(8, 55, 123, .86)',
        '--theme-list-row-border': 'rgba(223, 247, 255, .2)',
        '--theme-active-bg': 'linear-gradient(180deg, #22a6ff 0%, #075ecb 100%)',
        '--theme-active-text': '#ffffff',
        '--theme-gold-bg': 'linear-gradient(180deg, #FFD426 0%, #FF7E13 100%)',
        '--theme-gold-text': '#290000',
        '--theme-banner-bg': imageUrl(assets.home.bannerBg),
        '--theme-home-frame-corner-top-left': imageUrl(assets.home.frameCorners.topLeft),
        '--theme-home-frame-corner-top-right': imageUrl(assets.home.frameCorners.topRight),
        '--theme-home-frame-corner-bottom-left': imageUrl(assets.home.frameCorners.bottomLeft),
        '--theme-home-frame-corner-bottom-right': imageUrl(assets.home.frameCorners.bottomRight),
        '--theme-home-event-card-corner-top-left': imageUrl(assets.home.eventCardCorners.topLeft),
        '--theme-home-event-card-corner-top-right': imageUrl(assets.home.eventCardCorners.topRight),
        '--theme-home-event-card-corner-bottom-left': imageUrl(assets.home.eventCardCorners.bottomLeft),
        '--theme-home-event-card-corner-bottom-right': imageUrl(assets.home.eventCardCorners.bottomRight),
        '--theme-home-game-section-header-bg': imageUrl(assets.home.gameSectionHeaderBg),
        '--theme-home-jackpot-bg': imageUrl(assets.home.jackpotBg),
        '--theme-notification-bg-top1': imageUrl(assets.notification.bgTop1),
        '--theme-common-frame-corner-top-left': imageUrl(assets.common.frameCorners.topLeft),
        '--theme-common-frame-corner-top-right': imageUrl(assets.common.frameCorners.topRight),
        '--theme-common-frame-corner-bottom-left': imageUrl(assets.common.frameCorners.bottomLeft),
        '--theme-common-frame-corner-bottom-right': imageUrl(assets.common.frameCorners.bottomRight),
        '--theme-login-popup-image-bg': imageUrl(assets.login.popupBg),
        '--theme-home-classify-fixed-bg': 'linear-gradient(180deg, rgba(223, 247, 255, .04) 0%, rgba(223, 247, 255, 0) .16rem), linear-gradient(180deg, rgba(15, 59, 114, .98) 0%, rgba(8, 32, 64, .98) 100%)',
        '--theme-home-classify-item-bg': 'radial-gradient(circle at 12% 0, rgba(91, 178, 255, .2) 0, rgba(91, 178, 255, 0) 26%), linear-gradient(180deg, rgba(223, 247, 255, .1) 0%, rgba(223, 247, 255, 0) .1rem), linear-gradient(180deg, rgba(20, 99, 195, .96) 0%, rgba(7, 53, 119, .99) 100%)',
        '--theme-home-classify-icon-bg': '#0f66c8',
        '--theme-home-classify-nav-bg': 'linear-gradient(180deg, rgba(223, 247, 255, .12) 0%, rgba(223, 247, 255, 0) .12rem), linear-gradient(180deg, rgba(17, 88, 179, .96) 0%, rgba(5, 45, 103, .99) 100%)',
        '--theme-home-classify-nav-border': 'rgba(223, 247, 255, .18)',
        '--theme-home-classify-nav-shadow': 'inset 0 1px 0 rgba(229, 248, 255, .08), 0 .04rem .1rem rgba(4, 16, 34, .16)',
        '--theme-home-banner-panel-bg': 'linear-gradient(135deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .02), rgba(5, 48, 106, .5))',
        '--theme-home-section-top-bg': 'linear-gradient(180deg, rgba(6, 49, 112, .66) 0%, rgba(6, 49, 112, 0) 100%)',
        '--theme-home-notice-line-bg': 'linear-gradient(180deg, #5dc3ff 0%, #0867d5 100%)',
        '--theme-home-notice-item-bg': 'linear-gradient(-90deg, rgba(6, 49, 112, 0) 0%, rgba(6, 49, 112, .82) 100%)',
        '--theme-home-notice-icon-filter': 'brightness(0) saturate(100%) invert(69%) sepia(63%) saturate(1291%) hue-rotate(176deg) brightness(103%) contrast(101%) drop-shadow(0 .02rem .08rem rgba(93, 195, 255, .24))',
        '--theme-game-placeholder-surface': 'linear-gradient(180deg, rgba(13, 82, 172, .94) 0%, rgba(4, 39, 92, .99) 100%)',
        '--theme-game-placeholder-skeleton': 'linear-gradient(110deg, rgba(223, 247, 255, 0) 30%, rgba(93, 195, 255, .22) 50%, rgba(223, 247, 255, 0) 70%), linear-gradient(180deg, rgba(6, 49, 112, .58) 0%, rgba(3, 23, 53, .94) 100%)',
        '--theme-game-placeholder-fallback': 'radial-gradient(circle at 50% 18%, rgba(93, 195, 255, .18) 0%, rgba(93, 195, 255, 0) 36%), linear-gradient(180deg, rgba(6, 49, 112, .94) 0%, rgba(3, 23, 53, .99) 100%)',
        '--theme-game-placeholder-border': 'rgba(223, 247, 255, .14)',
        '--theme-game-title-bg': 'linear-gradient(180deg, rgba(5, 45, 103, .74) 0%, rgba(3, 23, 53, .92) 100%)',
        '--theme-game-title-text': '#dff7ff',
        '--theme-footer-border-top': imageUrl(assets.footer.borderTop),
        '--theme-footer-border-body': imageUrl(assets.footer.borderBody),
        '--theme-footer-title-text': '#dff7ff',
        '--theme-footer-body-text': '#b9dcf7',
        '--theme-footer-muted-text': 'rgba(223, 247, 255, .86)',
        '--theme-footer-copyright-text': '#eef9ff',
        '--theme-footer-menu-title-bg': 'linear-gradient(90deg, rgba(8, 55, 123, .92) 0%, rgba(3, 23, 53, .08) 100%)',
        '--theme-footer-menu-title-line': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-footer-menu-list-bg': 'linear-gradient(90deg, rgba(5, 36, 86, .64) 0%, rgba(3, 23, 53, .12) 100%)',
        '--theme-footer-menu-link-text': '#dff7ff',
        '--theme-home-banner-html-text': '#b9dcf7',
        '--theme-share-bg-top': imageUrl(assets.share.bgTop),
        '--theme-share-bg': imageUrl(assets.share.shareBg),
        '--theme-share-proxy-bg': imageUrl(assets.share.proxy),
        '--theme-person-vip-bg': imageUrl(assets.person.bgVip),
        '--theme-person-vip-pc-bg': imageUrl(assets.person.bgVipPc),
        '--theme-event-top-shell-bg': imageUrl(assets.event.topShellBg),
        '--theme-event-top-bg': imageUrl(assets.event.topBg),
        '--theme-event-top-right': imageUrl(assets.event.topRight),
        '--theme-event-detail-text': '#b9dcf7',
        '--theme-event-card-bg': 'rgba(6, 49, 112, .54)',
        '--theme-event-card-shadow': 'var(--theme-popup-panel-shadow)',
        '--theme-signin-vip-icon': imageUrl(assets.signIn.vipIcon),
        '--theme-signin-vip-icon-active': imageUrl(assets.signIn.vipIconActive),
        '--theme-signin-lock-icon': imageUrl(assets.signIn.lock),
        '--theme-signin-accent-text': '#FF8400',
        '--theme-signin-accent-border': '#33b7ff',
        '--theme-signin-progress-line': '#1c72c9',
        '--theme-signin-disabled-btn-bg': 'linear-gradient(180deg, rgba(142, 164, 185, .96) 0%, rgba(87, 105, 126, .98) 100%)',
        '--theme-signin-disabled-btn-text': '#e8f4ff',
        '--theme-signin-day-bg': 'linear-gradient(180deg, #2f8ee8 0%, #075ecb 100%)',
        '--theme-signin-day-border': '#b9dcf7',
        '--theme-signin-unlocked-bg': 'linear-gradient(180deg, #6bbdff 0%, #1767c4 99.29%)',
        '--theme-signin-secondary-amount-text': '#7bd0ff',
        '--theme-signin-nav-btn-bg': 'rgba(223, 247, 255, .18)',
        '--theme-signin-active-icon-shadow': '0px 2px 4px 0px rgba(3, 35, 82, .55)',
        '--theme-frame-line-vertical': 'linear-gradient(to bottom, transparent 0%, #1559ad 10%, #33b7ff 50%, #1559ad 85%, transparent 100%)',
        '--theme-frame-line-horizontal': 'linear-gradient(to right, transparent 0%, #347fd8 15%, #33b7ff 50%, #347fd8 85%, transparent 100%)',
        '--theme-tabbar-shell-bg': '#0755c6',
        '--theme-tabbar-text': 'rgba(255, 255, 255, .68)',
        '--theme-tabbar-active-text': '#ffffff',
        '--theme-tabbar-float-bg': 'linear-gradient(180deg, rgba(4, 31, 79, .96) 0%, rgba(10, 67, 140, .98) 100%)',
        '--theme-tabbar-divider': 'rgba(97, 191, 255, .2)',
        '--theme-tabbar-active-bg': [
            imageUrl(assets.tabbar.activeBorders[0]),
            imageUrl(assets.tabbar.activeBorders[1]),
            imageUrl(assets.tabbar.activeBorders[2]),
            imageUrl(assets.tabbar.activeBorders[3]),
            'linear-gradient(180deg, #22a6ff 0%, #075ecb 100%)'
        ].join(','),
        '--theme-tabbar-active-bg-size': '.72rem .45rem, .72rem .45rem, .72rem .45rem, .72rem .45rem, 100% 100%',
        '--theme-tabbar-active-bg-position': 'top left, top right, bottom left, bottom right, bottom left',
        '--theme-popup-bg': 'linear-gradient(180deg, #06295b 0%, #07428b 100%)',
        '--theme-popup-overlay-bg': 'rgba(3, 18, 42, .72)',
        '--theme-popup-close-bg': '#062b61',
        '--theme-popup-close-border': '#347fd8',
        '--theme-popup-panel-bg': 'rgba(6, 49, 112, .54)',
        '--theme-popup-panel-fill': '#073a78',
        '--theme-popup-panel-border': 'linear-gradient(180deg, rgba(91, 178, 255, .35), rgba(43, 137, 242, .18))',
        '--theme-popup-panel-shadow': 'inset .16rem .16rem .58rem 0 rgba(255, 255, 255, .16), inset -.16rem -.16rem .58rem 0 rgba(91, 178, 255, .12)',
        '--theme-panel-strong-bg': 'linear-gradient(180deg, #0e6ed2 0%, #063f90 100%)',
        '--theme-card-strong-bg': 'linear-gradient(180deg, #0b4f9e 0%, #062a61 100%)',
        '--theme-card-strong-border': '#347fd8',
        '--theme-popup-tabs-bg': 'rgba(8, 55, 123, .82)',
        '--theme-popup-mask-bg': 'rgba(5, 35, 82, .52)',
        '--theme-popup-box-bg': 'rgba(6, 49, 112, .92)',
        '--theme-popup-box-border': '#347fd8',
        '--theme-popup-box-shadow': 'inset 0 0 .1rem 0 rgba(91, 195, 255, .48)',
        '--theme-popup-amount-text': '#FFD426',
        '--theme-sidebar-bg': [
            'linear-gradient(180deg, rgba(9, 76, 170, .96) 0%, rgba(3, 23, 53, .98) 100%)',
            imageUrl(assets.home.pageBg)
        ].join(','),
        '--theme-sidebar-bg-size': '100% 100%, cover',
        '--theme-sidebar-border': 'rgba(97, 191, 255, .24)',
        '--theme-sidebar-menu-item-border': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-sidebar-hot-bg': imageUrl(assets.sidebar.hotBg),
        '--theme-sidebar-item-text': '#b9dcf7',
        '--theme-sidebar-item-active-bg': 'linear-gradient(-90deg, rgba(6, 49, 112, 0) 0%, #1f9dff 100%)',
        '--theme-sidebar-item-active-line': 'linear-gradient(180deg, #5dc3ff 0%, #0867d5 100%)',
        '--theme-sidebar-control-bg': '#062b61',
        '--theme-sidebar-control-border': '#347fd8',
        '--theme-sidebar-service-bg': 'linear-gradient(180deg, #31a8ff 0%, #075ecb 100%)',
        '--theme-sidebar-drawer-mask-bg': 'rgba(4, 35, 82, .58)'
    }
}
